'use client';

import clsx from 'clsx';
import Image from 'next/image';
import Link from 'next/link';

export default function Logo({
    href = '/',
    className = '',
    alt = 'Logo',
    priority = false,
    type = 'normal',
}) {
    const altText = alt ?? process.env.NEXT_PUBLIC_COMPANY_NAME ?? 'Logo';

    return (
        <Link href={href} className={clsx('inline-block', className)}>
            {type === 'normal' && (
                <Image
                    src="/logo.png"
                    alt={altText}
                    width="447"
                    height="348"
                    priority={priority}
                    className="block w-full h-auto"
                />
            )}
            {type === 'inverse' && (
                <Image
                    src="/logo.png"
                    alt={altText}
                    width="447"
                    height="348"
                    priority={priority}
                    className="block w-full h-auto"
                />
            )}
        </Link>
    );
}
